import React, { PureComponent } from 'react';
import FlagIcon from './flag-icon';
import storeFrontsArr from '../../commons/storeFronts';

class modalPaises extends PureComponent {
  constructor() {
    super();
    this.state = {
      languageSelector: 'mx',
      languageText: 'Mexico - Español',
    };
  }
  render() {
    const { openLanguage } = this.props;
    const { languageSelector, languageText } = this.state;
    return (
      <div className='ModalPaises'>
        <div className='Modal-inner-paises'>
          <div className='Modal-overlay Modal-overlay--isOpen'></div>
          <div className='Modal-body-paises Modal-body--isOpen Modal-body--medium has-noDefaultTopBar' tabIndex='0'>
            <div className='Modal-content-paises'>
              <div className='StorefrontSelector' tabIndex='-1'>
                <div className='StorefrontSelector-heading'>
                  <h3><span>Selecciona tu idioma y ubicación</span></h3>
                  <button className='StorefrontSelector-close'
                    onClick={ openLanguage }>
                    <span className='Icon Icon--xThin'></span>
                  </button>
                </div>
                <div className='StorefrontSelector-wrapDropdown'>
                  <div className='StorefrontSelector-dropdown'>
                    <label><span>Idioma y ubicación</span></label>
                    <div className='Dropdown Dropdown--darkBkgd'>
                      <div className='Dropdown-listTrigger Dropdown-listTrigger--flagIcon'>
                        <FlagIcon
                          svgID={ languageSelector }
                          className='Dropdown-flagIcon' />
                        <span className='Dropdown-selectedText'>{ languageText }</span>
                        <span className='Dropdown-icon Icon Icon--arrowSmallDown'></span>
                      </div>
                      <select ref='optionSelected' aria-hidden='true'
                        className='Dropdown-select' id='language'
                        onChange={ (e) => this.setLanguage(e) } >
                        {
                          storeFrontsArr.map(values => {
                            return (
                              <option value={values.languages}
                                key={values.languages}>{values.text}</option>
                            );
                          })
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div className='StorefrontSelector-saveButton'><button aria-disabled='false' className='Btn Btn--filledRed'
                  type='button'><span>Guardar</span></button></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  setLanguage = () => {
    if (this.refs.optionSelected) {
      const valueSelect = this.refs.optionSelected.value;
      const storeFront = valueSelect.slice(3, 5);
      let correctText = '';
      storeFrontsArr.forEach(values => {
        if (valueSelect === values.languages) {
          correctText = values.text;
        }
      });

      this.setState({ languageSelector: storeFront, languageText: correctText });
    }
  }
}

export default modalPaises;
